import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * MealPlan Home: the weekly planner is the product center
 * (PRODUCT_PLAN.md — guiding principle). The template's todo dashboard
 * was removed from navigation.
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: () => {
    // oxlint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/planner",
      search: (prev) => prev,
    });
  },
});
